import { useCallback, useRef } from "react";
import { FOLDER_TREE_DROPPABLE_NODE_SELECTOR, bindJqueryFolderTreeDroppable } from "./jquery/bindJqueryFolderTreeDroppable.js";
import { useDebouncedTreeRefresh } from "./useDebouncedTreeRefresh.js";
function useJqueryFolderTreeDroppable({ $, root, nodeSelector = FOLDER_TREE_DROPPABLE_NODE_SELECTOR, activeClass, hoverClass, tolerance = "pointer", onDrop, refreshDelayMs = 200 }) {
    const onDropRef = useRef(onDrop);
    onDropRef.current = onDrop;
    const makeDroppable = useCallback(()=>bindJqueryFolderTreeDroppable({
            $,
            root,
            nodeSelector,
            activeClass,
            hoverClass,
            tolerance,
            onDrop: (event, ui)=>onDropRef.current(event, ui)
        }), [
        $,
        activeClass,
        hoverClass,
        nodeSelector,
        root,
        tolerance
    ]);
    const refreshDroppable = useDebouncedTreeRefresh(makeDroppable, refreshDelayMs);
    return {
        makeDroppable,
        refreshDroppable,
        FOLDER_TREE_DROPPABLE_NODE_SELECTOR
    };
}
export { FOLDER_TREE_DROPPABLE_NODE_SELECTOR, useJqueryFolderTreeDroppable };
